const valueCache: Record<string, any> = {};

export const getCachedValue = (name: string) => valueCache[name];
export const setCachedValue = (name: string, value: unknown) =>
  (valueCache[name] = value);

export const setCacheValues = (values: Record<string, any>) => {
  Object.assign(valueCache, values);
};
